export default [
  { id: "chest", title: "Chest", navLink: "/chest" },
  { id: "inventory", title: "Inventory", navLink: "/inventory" },
  {
    id: "marketplace",
    title: "Marketplace",
    children: [
      { id: "sell-market", title: "Sell Order", navLink: "/marketplace/sell-order" },
      // { id: "buy-market", title: "Buy Order", navLink: "/marketplace/buy-order" },
      { id: "rent-market", title: "Rent Order", navLink: "/marketplace/for-rent" },
      { id: "auction-market", title: "Auction", navLink: "/marketplace/auction" },
      { id: "vetrava-market", title: "veTRAVA", navLink: "/marketplace/ve-trava" },
    ],
  },
  {
    id: "mission",
    title: "Mission",
    children: [
      { id: "nft-farming", title: "NFT Farming", navLink: "/nft-farming" },
      { id: "heuristic-farming", title: "Heuristic Farming", navLink: "/heuristic-farming" },
      { id: "expedition", title: "Expedition", navLink: "/expedition" },
      { id: "treasure-map", title: "Treasure Map", navLink: "/treasure-map" },
      { id: "dilution-staking", title: "Dilution Staking", navLink: "/dilution-staking" },
    ],
  },
  { id: "profile", title: "Profile", navLink: "/profile/me" },
  {
    id: "ticket",
    title: "Ticket",
    navLink: "/ticket/counter",
    forceShowInSidebar: [
      { id: "exchange", title: "Exchange", navLink: "/ticket/exchange" },
      { id: "counter", title: "Counter", navLink: "/ticket/counter" },
      { id: "marketplace", title: "Marketplace", navLink: "/ticket/marketplace" },
      { id: "staking", title: "Staking", navLink: "/ticket/staking" },
      { id: "offering", title: "Public Offering", navLink: "/ticket/offering" },
      { id: "dex", title: "Trade", navLink: "/ticket/dex" },
      {
        id: "documents",
        title: "Documents",
        externalLink: true,
        newTab: true,
        navLink: "https://docs.trava.finance/nfts/trava-nft-ticket",
      },
    ],
  },
  // { id: "bridge", title: "Bridge", navLink: "/bridge" },
];

export const rightNavConfig = [
  {
    id: "leaderboard",
    title: "Dashboard",
    children: [
      {
        id: "statistic",
        title: "Statistics",
        externalLink: true,
        newTab: true,
        navLink: "https://nft-app.trava.finance/leaderboard/statistic",
      },
      {
        id: "leaderboard2",
        title: "Leaderboard",
        externalLink: true,
        newTab: true,
        navLink: "https://nft-app.trava.finance/leaderboard/trava-armoury",
      },
    ],
  },
];
